import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Member extends Component {
    render() {
        return (
            <div className="col-lg-6 col-md-12 mb-r">
                <div className="col-md-6 float-left mb-4">
                    <div className="avatar">
                        <picture>
                            <source type="image/webp"  srcset={this.props.webppicture} />
                            <img src={this.props.picture} loading="lazy" className="rounded z-depth-1 img-fluid" alt={this.props.firstname + ' ' + this.props.lastname} />
                        </picture>
                    </div>
                </div>
                <div className="col-md-6 float-right">
                    <h4><strong>{this.props.firstname + ' ' + this.props.lastname}</strong></h4>
                    <h6 className="font-bold grey-text mb-4">
                        {this.props.instruments.map((instrument, index) =>
                            <span key={index}>{instrument.description}{index < this.props.instruments.length - 1 && ', '}</span>
                        )}
                    </h6>
                    <p className="grey-text font-italic" style={{ fontSize: ".95em" }}>{this.props.description}</p>
                </div>
            </div>
        );
    }
}

Member.propTypes = {
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    pictureurl: PropTypes.string,
    description: PropTypes.string,
    instruments: PropTypes.array
};

export default Member;


// WEBPACK FOOTER //
// ./src/components/Member.js